// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_im-0";
export var optionCard = "_im-1";